import { api } from '@api/index';
import { actions } from '../common/reducer';
import { apiCall } from '../common/effects';
import * as notifications from '../notification/effects';
import i18next from 'i18next';
import { formatKbytes } from '@lib/format-kb';

export const editUser = (data) => async (dispatch) => {
  const response = await dispatch(apiCall(() => api.editUser(data)));

  if (!response || response.status !== 200) {
    dispatch(
      notifications.showNotification({
        type: 'ERROR',
        message: i18next.t('cabinet.notification.editProfile.error'),
      })
    );

    return;
  }

  if (response.data.success) {
    dispatch(
      notifications.showNotification({
        type: 'SUCCESS',
        message: i18next.t('cabinet.notification.editProfile.success'),
      })
    );
  } else {
    dispatch(
      notifications.showNotification({
        type: 'ERROR',
        message: i18next.t('cabinet.notification.editProfile.error'),
      })
    );
  }

  dispatch(fetchUser());
};

export const deleteUser = () => async (dispatch) => {
  const response = await dispatch(apiCall(() => api.deleteUser()));

  if (!response || response.status !== 200) {
    dispatch(
      notifications.showNotification({
        type: 'ERROR',
        message: i18next.t('cabinet.notification.deleteProfile.error'),
      })
    );

    return;
  }

  dispatch(
    notifications.showNotification({
      type: 'SUCCESS',
      message: i18next.t('cabinet.notification.deleteProfile.success'),
    })
  );
};

export const fetchUser = (callback) => async (dispatch, getState) => {
  const lastUpdate = getState().common.userUpdate;
  if (Date.now() - lastUpdate < 2000) return;
  dispatch(actions.setLastUpdate('userUpdate'));

  const response = await dispatch(apiCall(() => api.getUser()));

  if (!response || response.status !== 200) {
    dispatch(
      notifications.showNotification({
        type: 'ERROR',
        message: i18next.t('cabinet.notification.fetch.error'),
      })
    );

    return;
  }

  const {
    name,
    avatar,
    email,
    email_change,
    id,
    about,
    disk_usage,
    status,
    country,
    currency,
    linked_accounts,
    logo,
  } = response.data;
  const freeSpace = disk_usage.quota_limit - disk_usage.quota_usage;
  const quotaFreePercent = (disk_usage.quota_usage / disk_usage.quota_limit) * 100;
  const isConfirmEmail = status === 1;

  const user = {
    username: name,
    about,
    avatar,
    logo,
    id,
    country,
    currencyCode: currency,
    isConfirmEmail,
    linked_accounts,
    email: email_change || email,
    origEmail: email,
    hasQuota: !!disk_usage,
    quotaLimit: formatKbytes(disk_usage.quota_limit),
    quotaUsage: formatKbytes(disk_usage.quota_usage),
    quotaFree: freeSpace > 0 ? formatKbytes(freeSpace) : 0,
    quotaFreePercent: quotaFreePercent < 100 ? quotaFreePercent : 100,
  };

  dispatch(actions.setUserData(user));

  if (typeof callback === 'function') {
    callback();
  }
};

export const confirmEmail = (code) => async (dispatch) => {
  const response = await dispatch(apiCall(() => api.confirmEmail({ code })));

  if (!response || response.status !== 200 || (!response.data.success && !response.data.errorText)) {
    dispatch(
      notifications.showNotification({
        type: 'ERROR',
        message: i18next.t('cabinet.notification.confirmEmail.error'),
      })
    );

    return;
  }

  if (!response.data.success && response.data.errorText) {
    dispatch(
      notifications.showNotification({
        type: 'ERROR',
        message: response.data.errorText,
      })
    );

    return;
  }

  dispatch(
    notifications.showNotification({
      type: 'SUCCESS',
      message: i18next.t('cabinet.notification.confirmEmail.success'),
    })
  );

  dispatch(fetchUser());
};

export const resendConfirmEmail = () => async (dispatch) => {
  const response = await dispatch(apiCall(() => api.resendConfirmEmail()));

  if (!response || response.status !== 200 || !response.data.success) {
    dispatch(
      notifications.showNotification({
        type: 'ERROR',
        message: i18next.t('cabinet.notification.resendConfirmEmail.error'),
      })
    );

    return;
  }

  dispatch(
    notifications.showNotification({
      type: 'SUCCESS',
      message: i18next.t('cabinet.notification.resendConfirmEmail.success'),
    })
  );
};

export const checkFileByFormat = (file, accept) => async (dispatch) => {
  const formats = accept.replace(/[.\s]/g, '').split(',');
  const format = file.type.split('+')[0].split('/')[1];
  const res = formats.indexOf(format) !== -1;

  if (!res) {
    dispatch(
      notifications.showNotification({
        type: 'ERROR',
        message: i18next.t('cabinet.notification.loadImage.error'),
      })
    );
  }

  return res;
};
